import { Descriptions, DescriptionsProps } from 'antd';

export type DescriptionsAtomProps = DescriptionsProps;

const DescriptionsAtom = Descriptions;

export default DescriptionsAtom;
